<div class="flex flex-col" [ngClass]="!isReport ?'items-start border rounded border-zen/10':'gap-2 px-4'" (click)="logData(benchmarkData)"
    *ngIf="benchmarkData">
    <ng-container *ngFor="let data of benchmarkData; let last = last">
        <ng-container *ngTemplateOutlet="isReport ? reportTemplate:benchmarkBlock; context: {
        label: data?.benchmarkType,
       value: (!data?.value && data?.value != 0)   ? -1000 : data?.value,
        icon: data?.icon,
        diff: (!data?.benchmarkDiff && data?.benchmarkDiff != 0)  ? -1000 : data?.benchmarkDiff,
        last: benchmarkRequest?.showTopPerformers && (benchmarkData.length === 1 || benchmarkData.length === 2)
          ? null : last
      }"></ng-container>

        <ng-container
            *ngIf="data?.benchmarkType === 'mena' && benchmarkRequest?.showTopPerformers && data?.topPerformer != null">
            <ng-container *ngTemplateOutlet="isReport ? reportTemplate:benchmarkBlock; context: {
          label: 'topPerformer',
          value: (!data?.topPerformer && data?.topPerformer != 0)   ? -1000 : data?.topPerformer,
          icon: BenchmarkIconEnum.topPerformer,
          diff: (!data?.topPerformerDiff && data?.topPerformerDiff != 0)  ? -1000 : data?.topPerformerDiff,
          last: last
        }"></ng-container>
        </ng-container>
    </ng-container>
</div>
<div class="flex flex-col items-start  gap-3 mt-6  pt-6" *ngIf="factor==='overall'">
    <h5 class="uppercase text-zen-primaryLight text-xs font-medium">
        {{"txtBenchmarkLegend" |translate:language:ModuleNames.Shared}}
    </h5>
    <div class="flex flex-col items-start gap-2" *ngFor="let data of benchmarkData">
        <div class="flex flex-row gap-1 items-center">
            <i [class]="data?.icon" class="fa-regular text-sm text-zen text-opacity-60 w-5 h-5"></i>
            <span class="text-zen-primaryLight text-xs">{{data?.benchmarkType |translate:language:ModuleNames.Shared
                }} <strong class="text-zen-primaryDark">{{data?.benchmarkType == 'industry'? benchmarkRequest?.industryText
                    :
                    data?.benchmarkType=='country' ? benchmarkRequest?.regionOrCountryText
                    :''}}</strong></span>
        </div>
    </div>
    <div class="flex flex-col items-start gap-2" *ngIf="benchmarkRequest?.showTopPerformers">
        <div class="flex flex-row gap-1 items-center">
            <i [class]="BenchmarkIconEnum.topPerformer" class="fa-regular text-sm text-zen text-opacity-60 w-5 h-5"></i>
            <span class="text-zen-primaryLight text-xs">{{'topPerformer' |translate:language:ModuleNames.Shared
                }}</span>
        </div>
    </div>

</div>

    <ng-template #benchmarkBlock let-label="label" let-value="value" let-icon="icon" let-diff="diff" let-last="last">
        <div [@smallAnimation] [matTooltip]="label | translate:language:ModuleNames.Shared"
            class="flex flex-row gap-1 pl-1 pr-2 items-center h-8 leading-8 w-full"
            [ngClass]="{'border-b border-zen/10': !last}">
            <i [class]="icon" class="fa-regular text-sm text-zen text-opacity-60 w-5 h-5"></i>
            <div class="flex flex-row items-center justify-between text-xs font-medium w-full">
                <h5 class="text-zen-primaryDark">
                    {{ value === -1000 ? ("txtNA" | translate:language:ModuleNames.Engagement) : (value |
                    number:'1.1-1')
                    + '%'
                    }}
                </h5>
                <div [ngClass]="{'text-zen-red': (diff < 0 && diff != -1000), 'text-zen-green': diff > 0}"
                    class="font-medium text-xs w-1/2 flex flex-row items-center justify-end">
                    <span class="px-1">
                        {{ diff === -1000 ? ("txtNA" | translate:language:ModuleNames.Engagement) : (diff |
                        number:'1.1-1') +
                        '%' }}
                    </span>
                    <i [ngClass]="{'fa-down': (diff < 0 && diff != -1000), 'fa-up': diff > 0}" class="fa-solid"></i>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template #reportTemplate let-label="label" let-value="value" let-icon="icon" let-diff="diff" let-last="last">
        <div class="flex flex-row gap-2">
            <div class="flex flex-col gap-2.5 p-2 w-1/2 border border-zen border-opacity-10 rounded-sm">
                <div class="flex flex-col gap-1">
                    <h5 class="text-xxs text-zen m-0">
                        {{ label | translate:language:ModuleNames.Shared }}
                    </h5>
                    <strong class="text-xxs text-zen-primaryDark">
                        {{ label == 'industry' ? benchmarkRequest?.industryText : label == 'country' ?
                        benchmarkRequest?.regionOrCountryText : '' }}
                    </strong>
                </div>
                <h5 class="text-sm leading-5 text-zen-dark"> {{ value === -1000 ? ("txtNA" |
                    translate:language:ModuleNames.Engagement) : (value |
                    number:'1.1-1')
                    + '%'
                    }}</h5>
            </div>
            <div class="flex flex-col gap-2.5 p-2 w-1/2 border border-zen border-opacity-10 rounded-sm">
                <h5 class="text-xxs text-zen">%{{ "txtDifference" |
                    translate:language:ModuleNames.Engagement }}</h5>
                <h5 [ngClass]="{'text-zen-red': (diff < 0 && diff != -1000), 'text-zen-green': diff > 0}"
                    class="text-sm leading-5"><i [ngClass]="{'fa-caret-up':diff > 0, 'fa-caret-down':diff < 0}"
                        class="fa-regular"></i>{{ diff === -1000 ? ("txtNA" |
                    translate:language:ModuleNames.Engagement) : (diff |
                    number:'1.1-1') +
                    '%' }}</h5>
            </div>
        </div>
    </ng-template>